import React from "react";

/**
 * What the post / guide forms say about their pillar and tag lists. An empty
 * dropdown used to be the only sign that the lists never loaded; this names
 * the state and offers Retry. Renders nothing once the lists are in.
 */
const TaxonomyStatus = ({ state, onRetry }) => {
  if (state === "ready" || state === "idle" || !state) return null;
  const failed = state === "failed";
  return (
    <div
      role={failed ? "alert" : "status"}
      className="d-flex align-items-center justify-content-between gap-3 mb-3 px-3 py-2"
      style={{
        border: `1px solid ${failed ? "#E5484D" : "var(--ps-border)"}`,
        borderRadius: 8,
        background: "var(--ps-surface-2)",
      }}
    >
      <span style={{ color: failed ? "#FF8A8F" : "var(--ps-text-muted)" }}>
        {failed
          ? "Unable to load pillars and tags. Saving is off until they load."
          : "Loading pillars and tags…"}
      </span>
      {failed && (
        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={onRetry}>
          Retry
        </button>
      )}
    </div>
  );
};

export default TaxonomyStatus;
